module.exports = global["jQuery"] = require("-!/app/node_modules/babel-loader/lib/index.js??ref--11-0!./jquery.1.11.1.js");